import { render, staticRenderFns } from "./PrintVolumeTrendIcon.vue?vue&type=template&id=359ace6a&scoped=true"
import script from "./PrintVolumeTrendIcon.vue?vue&type=script&lang=js"
export * from "./PrintVolumeTrendIcon.vue?vue&type=script&lang=js"
import style0 from "./PrintVolumeTrendIcon.vue?vue&type=style&index=0&id=359ace6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ace6a",
  null
  
)

export default component.exports